import { render, staticRenderFns } from "./top-logs.vue?vue&type=template&id=08e33602&scoped=true"
import script from "./top-logs.vue?vue&type=script&lang=js"
export * from "./top-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e33602",
  null
  
)

export default component.exports